/* ONE BOUT — ob-quick-add.js (2026-09-26): product card quick add on touch devices.
   Pointer devices reveal the size panel on hover (ob-base.css §8b); here the "+" toggle opens/closes it
   (.is-open + aria-expanded), an outside tap or Escape closes it, and every panel closes after a successful add
   (theme.js `.one-bout-quick-buy` handler → cart:change). Loaded once from layout/theme.liquid. */
(function () {
  const OPEN = 'is-open';

  function setOpen(root, open) {
    root.classList.toggle(OPEN, open);
    const toggle = root.querySelector('[data-ob-qa-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  function closeAll(except) {
    document.querySelectorAll('[data-ob-qa].' + OPEN).forEach((root) => { if (root !== except) setOpen(root, false); });
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ob-qa-toggle]');
    if (toggle) {
      event.preventDefault();
      const root = toggle.closest('[data-ob-qa]');
      const open = !root.classList.contains(OPEN);
      closeAll(root);
      setOpen(root, open);
      return;
    }
    if (!event.target.closest('[data-ob-qa]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-ob-qa].' + OPEN);
    if (!open) return;
    closeAll();
    const toggle = open.querySelector('[data-ob-qa-toggle]');
    if (toggle && toggle.offsetParent) toggle.focus();
  });

  document.addEventListener('cart:change', () => closeAll());
})();
